/**
 * Suburbs
 * 
 * @Author: Focci
 * @Date: 2024-01-11 10:26:24
 * @Last Modified by: Focci
 * @Last Modified time: 2024-01-11 10:26:24
 */

import PropTypes from 'prop-types'
import clsx from 'clsx'
import { useEffect, useMemo } from 'react'
import { isAU } from '@lib/utils'
import useFetch from '@hook/useFetch'
import { isArray, map, times } from 'lodash-es'
import { Skeleton } from '@mui/material'
import SuburbCheckbox from './SuburbCheckbox'

export default function Suburbs({ 
  data, 
  districtId, 
  onSuburbDataReady = () => {},
  ...props 
}) {
  const { data: suburbs, isLoading } = useFetch(isAU ? `suburbs?id=${districtId}` : null)
  const options = useMemo(() => {
    if(!isAU) return data
    return map(
      isArray(suburbs) ? suburbs : [],
      (item) => ({
        label: item.name || item.en_name,
        lat: parseFloat(item.latitude),
        lng: parseFloat(item.longitude),
        type: 'suburb',
        slug: item.slug,
        value: parseFloat(item.id)
      })
    )
  }, [data, suburbs])

  useEffect(() => {
    isAU && onSuburbDataReady({ options, districtId })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [districtId, options])
  
  if(isLoading) {
    return (
      <div className="flex flex-col flex-auto gap-2">
        {
          times(3, String).map((_, index) => (
            <Skeleton
              key={index} 
              variant="rectangular" 
              className={clsx(['rounded-sm h-4'])}
              style={{ width: `${((12 - index) / 12) * 100}%` }} 
            />
          ))
        }
      </div>
    )
  }

  return (
    <SuburbCheckbox
      data={options}
      {...props}
    />
  )
}

Suburbs.propTypes = {
  data: PropTypes.array,
  districtId: PropTypes.number,
}
